import React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export const PrismMark = ({ className, size = 40 }) => (
  <img
    src="/logo/IMG_4999-removebg-preview.png"
    width={size}
    height={size}
    className={cn("object-contain", className)}
    alt="AXOR Technologies"
  />
);

export const Logo = ({
  className,
  showWordmark = true,
  size = 38,
  light = true,
}) => (
  <Link
    to="/"
    className={cn("inline-flex items-center gap-3", className)}
    aria-label="Axor Technologies home"
    data-testid="logo-home-link"
  >
    <PrismMark
      size={size}
      className="drop-shadow-[0_4px_16px_rgba(22,184,212,0.35)]"
    />

    {showWordmark && (
      <span className="flex flex-col leading-none">
        <span
          className={cn(
            "text-lg font-extrabold tracking-[0.16em]",
            light ? "text-axor-white" : "text-axor-navy",
          )}
        >
          AXOR
        </span>

        <span
          className={cn(
            "text-[9px] font-semibold uppercase tracking-[0.34em]",
            light ? "text-axor-aqua" : "text-axor-cyan",
          )}
        >
          Technologies
        </span>
      </span>
    )}
  </Link>
);
